module.exports = __webpack_public_path__ + "img/trip_selected.6a3bd8fa.png";